import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-back-button',
    standalone: false,
    templateUrl: './back-button.component.html',
    styleUrl: './back-button.component.css'
})
export class BackButtonComponent {
    @Input() route: string | any[] | null = null;
    /** Optional query params when navigating to route (e.g. { accountNo: 123 }). */
    @Input() queryParams: Record<string, any> | null = null;
    @Input() label: string = 'Back';
    @Input() useHistoryBack: boolean | null = null;

    constructor(
        private router: Router,
        public activatedRoute: ActivatedRoute
    ) { }
 
    goBack(): void {
        // If route is explicitly provided and useHistoryBack is not requested, navigate there.
        if (this.route && !this.useHistoryBack) {
            const navExtras = this.queryParams ? { queryParams: this.queryParams } : {};
            if (Array.isArray(this.route)) {
                this.router.navigate(this.route, navExtras);
            } else {
                this.router.navigate([this.route], navExtras);
            }
            return;
        }

        // Default: use browser history to go back so caller returns to previous page (keeps context)
        if (window && typeof window.history !== 'undefined' && window.history.length > 1) {
            window.history.back();
        } else {
            // Fallback: navigate up one level relative to current route
            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
        }
    }
}
